export const LINK_SORTING_MAP: Record<string, string> = {
  playerLink: 'player.displayName',
  teamLink: 'team.name',
  recipientPlayerLink: 'recipientPlayer.displayName',
};
